import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const modalContainerFn = /* @__PURE__ */ createRecipe('modalContainer', {
  "size": "small",
  "flexOrientation": "column"
}, [])

const modalContainerVariantMap = {
  "size": [
    "small",
    "medium",
    "large"
  ],
  "flexOrientation": [
    "column"
  ]
}

const modalContainerVariantKeys = Object.keys(modalContainerVariantMap)

export const modalContainer = /* @__PURE__ */ Object.assign(memo(modalContainerFn), {
  __recipe__: true,
  __name__: 'modalContainer',
  raw: (props) => props,
  variantKeys: modalContainerVariantKeys,
  variantMap: modalContainerVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, modalContainerVariantKeys)
  },
})